import React from 'react';

interface IIconProps {
    width?: number;
    height?: number;
}

export const PlusLarge = ({ width = 16, height = 16 }: IIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 10 10"
        fill="none"
    >
        <path
            d="M10 4.58333H5.41667V0H4.58333V4.58333H0V5.41667H4.58333V10H5.41667V5.41667H10V4.58333Z"
            fill="currentColor"
        />
    </svg>
);
